import { createContext } from 'react';

const MMMListViewContext = createContext();

export default MMMListViewContext;